import React from 'react';

import classnames from 'classnames';
import { isMembershipPriceId } from '../../../../../../utilities/membership';
import MembershipCardInfo, { MembershipCardInfoProps } from './MembershipCardInfo';

const MembershipCard = ({ priceId, info }: { priceId: string; info: MembershipCardInfoProps[] }) => {
  return (
    <div
      className={classnames('MembershipCard', {
        noMembership: !isMembershipPriceId(priceId),
      })}
    >
      {info?.map((infoData, i) => {
        return <MembershipCardInfo key={i} {...infoData} />;
      })}
    </div>
  );
};

export default MembershipCard;
